import { useMutation } from "@tanstack/react-query";
import { createUsers as apiCreateUsers } from "../../api/apiUsers";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateUsers() {
    const navigate = useNavigate();

    const {
        mutate: createUsers,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiCreateUsers(req),
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/users');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { isPending, error, createUsers, results };
}
